import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { ListGroupItem } from 'react-bootstrap'

export default function Token({
  active,
  selectToken,
  token,
}) {
  const expiry = token.getIn(['card', 'expiry'])
  let expired = false
  if (expiry && expiry.isBefore()) {
    expired = true
  }

  return (
    <ListGroupItem
      active={active}
      disabled={expired}
      onClick={() => selectToken(token.get('uuid'))}
    >
      <h4>
        {token.getIn(['card', 'number'])}
      </h4>

      {expired && (
        <p><strong>This card has expired.</strong></p>
      )}

      <p>
        {token.getIn(['card', 'name'])}
        {expiry && (
          <span className="text-muted"> &mdash; {expiry.format('MM/YY')}</span>
        )}
      </p>
    </ListGroupItem>
  )
}

Token.propTypes = {
  active: Pt.bool.isRequired,
  selectToken: Pt.func.isRequired,
  token: Ipt.record,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Payment/TokenSelector/Token.jsx